import React from 'react'

import { OrderStateTagProps } from 'common/components/statuses/order_state'
import { OrderHit } from 'common/server/orders'

import { VendorOrderState } from 'vendor/components/OrderState'

export type CellOrderStateProps = { notificationsCount?: number; order: OrderHit } & Pick<OrderStateTagProps, 'style'>

export const CellOrderState = ({ order, notificationsCount, ...props }: CellOrderStateProps) => {
  const { state, sub_state, has_open_delivery_issue, deliveries = [] } = order

  return (
    <VendorOrderState
      state={state}
      sub_state={sub_state}
      notificationCount={notificationsCount}
      showIssue={has_open_delivery_issue}
      deliveryIssues={deliveries?.map((d) => d.delivery_issue_type)}
      {...props}
    />
  )
}
